import { useTenantConfig } from '../../context/TenantConfigContext'
import HeroCentered from './HeroCentered'

const HERO_MAP = {
  'hero-centered': HeroCentered,
  HERO_VIDEO: HeroCentered,
  HERO_CENTERED: HeroCentered,
}

function DynamicHero() {
  const { getComponentKey } = useTenantConfig()
  const key = getComponentKey('hero')
  const HeroComponent = HERO_MAP[key] || HeroCentered
  return <HeroComponent />
}

export default DynamicHero
